import React, { useContext } from 'react';
import classnames from 'classnames';

import { InlineHubspotFormFragment } from '../../../../graphql.schema';
import { ModalRawHTML } from '../../RawHTML/ModalRawHTML';
import { RichTextField } from '../../RichTextField/RichTextField';
import { PageContext } from '../../PageContext';
import ContactForm from '../../ContactForm';
import * as styles from './StrapiInlineHubspotForm.module.scss';

type StrapiInlineHubspotFormPropType = InlineHubspotFormFragment & {
  hasRTL?: boolean;
  className?: string;
  showFormInHeader?: boolean;
  associateFunction?: Function | null;
  location?: Location
};
export const StrapiInlineHubspotForm: React.FC<StrapiInlineHubspotFormPropType> = ({
  title,
  description,
  html,
  hasRTL = false,
  showFormInHeader,
  className,
  associateFunction,
  ...props
}) => {
  const context = useContext(PageContext);

  return (
    <div className={classnames('strapi-inline-hubspot-form', styles.root, className)}>
      <div className="container">
        {context.websiteLocale.locale === 'he-IL' || context.websiteLocale.locale == 'ar-IL' ? (showFormInHeader ? <ContactForm
          title={{ id: 'details-title', defaultMessage: 'Leave details for conversation with  a study advisor' }}
          checkBox={{
            label: { id: 'details-checkbox', defaultMessage: 'I agree to receive educational and/or marketing information via email or SMS' },
            name: 'sms', placeholder: { id: 'contact-sms', defaultMessage: 'sms' }, type: 'checkbox', required: false
          }}
          fullInputs={[
            { name: 'FullName', placeholder: { id: 'contact-full-name', defaultMessage: 'Fullname' }, type: 'text', required: true },
            { name: 'phone', placeholder: { id: 'contact-phone-placeholder', defaultMessage: 'Phone' }, type: 'text', pattern: '05[0-9]{8}', required: true },
          ]} selectOptions={[]} inputs={[]}
          className={className}
          associateFunction={associateFunction}
        /> :
          <ContactForm
            isTestPage={`/${props?.location?.pathname?.split('/')[1]}` === context?.pathPrefixes?.english_tests}
            title={{ id: 'contact-title', defaultMessage: ' ' }}
            checkBox={{
              label: { id: 'contact-checkbox', defaultMessage: 'I agree to receive educational and/or marketing information via email or SMS' },
              name: 'sms', placeholder: { id: 'contact-sms', defaultMessage: 'sms' }, type: 'checkbox', required: false
            }}
            fullInputs={[
              { label: { id: 'contact-full-name', defaultMessage: 'Full Name' }, name: 'FullName', placeholder: { id: 'contact-full-name', defaultMessage: 'Fullname' }, type: 'text', required: true },
              { label: { id: 'contact-phone', defaultMessage: 'Phone' }, name: 'phone', placeholder: { id: 'contact-phone-placeholder', defaultMessage: 'Phone' }, type: 'text', pattern: '05[0-9]{8}', required: true },
            ]} selectOptions={[]} inputs={[]}
            associateFunction={associateFunction}
          />
        )
          : <div className={classnames('columns inverted', styles.wrapperColumn)}>
            <div className={classnames('column is-three-fifths', styles.titleContainer)}>
              <h2 className="title is-2">{title}</h2>
              <RichTextField content={description} />
            </div>
            <div className={classnames('columns')}>
              <div className={classnames(`column ${hasRTL ? 'is-6' : ''}`)}>
                <ModalRawHTML html={html} />
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  );
};
